// why is default wait is 16?
// Because to get 60fps (frames per second), we need 1000ms / 60 ~= 16ms
export function debounce<TContext, TReturn = void>(
    func: (...args) => TReturn, context: TContext = null, wait = 16) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

export function delay<TValue>(wait: number, value?: TValue) {
    return new Promise<TValue>(
        (resolve) => setTimeout(() => resolve(value), wait)
    );
}
